export function getISOStringDate(dateString: string): string {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");
    // eslint-disable-next-line no-magic-numbers

    return `${year}-${month}-${day}`;
}
